// extracted by mini-css-extract-plugin
module.exports = {"page-container":"Checkout_page-container__kqjCg"};